import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from "@angular/core"
import { ImageFilterService } from "@shared/services/image-filter.service"

@Component({
    selector: "ag-toggle-button-img",
    templateUrl: "./ag-toggle-button-img.component.html",
    styleUrl: "./ag-toggle-button-img.component.scss",
    standalone: false
})
export class AgToggleButtonImgComponent {
  @Input() optionList: LabelValueWithFilter[]
  @Input() widthPerOption: number = 80
  @Input() numberOfOptions: number = 2
  @Input() disabled: boolean = false
  @Input() initOption: number = 0

  @Output() public chosenOption = new EventEmitter<LabelValueWithFilter>()

  @ViewChildren("optionText") optionTexts: QueryList<ElementRef>

  selectedOption: LabelValueWithFilter
  disableField: boolean = false
  selectedNumber: string = "1"

  constructor(public imageFilter: ImageFilterService) {}

  ngOnInit() {
    if (this.optionList.length > 0) {
      this.select(this.optionList[this.initOption])
    }

    this.disableField = this.disabled
  }

  select(option: LabelValueWithFilter) {
    if (!this.disableField && this.optionList) {
      this.selectedOption = option
      this.chosenOption.emit(option)
      this.getSelectedNumber()
    }
  }

  getSliderWidth(): string {
    return `${this.widthPerOption}px`
  }

  getContainerWidth(): string {
    const totalWidth = this.numberOfOptions * this.widthPerOption + this.numberOfOptions * 4 + 4
    return `${totalWidth}px`
  }

  getTransform(): string {
    const optionIndex = parseInt(this.selectedNumber, 10) - 1
    if (optionIndex !== 0) return `translateX(${optionIndex * (this.widthPerOption + 4) + 4}px)`
    else return `translateX(${4}px)`
  }

  getSelectedNumber() {
    const number = this.optionList.findIndex((item) => item === this.selectedOption) + 1
    const option = number.toString()
    this.selectedNumber = option
  }
}

export interface LabelValueWithFilter {
  label: string
  value: any
  filter: boolean
}
